import { useMemo } from "react";

import { PreferredPharmacyHelper } from "../Helpers/PreferredPharmacyHelper";

export const usePreferredPharmacyHelper = (patientContactId: string): PreferredPharmacyHelper => useMemo(
    () => new PreferredPharmacyHelper(
        patientStore.PatientModels[patientContactId]?.Addresses,
        sessionStore.getCurrentEmployee()
    ),
    [patientContactId]
);
